export const METRIC_MEM_USED = "mem.used";
export const METRIC_MEM_TOTAL = "mem.total";
export const METRIC_CPU_USED_PCNT = "cpu.used_pcnt";
